import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adminComponent from './admin.component';

// Reports
import Episodes from '../../common/admin/episodes/episodes';
import Users from '../../common/admin/users/users';
import Specialties from '../../common/admin/specialties/specialties';
import Episodevalue from '../../common/admin/episodevalue/episodevalue';
import Drg from '../../common/admin/drgs/drgs';
import Site from '../../common/admin/site/site';

let adminModule = angular.module('admin', [
  uiRouter,
  Episodes.name,
  Users.name,
  Specialties.name,
  Episodevalue.name,
  Drg.name,
  Site.name
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/');

  $stateProvider

  .state('admin', {
    url: '/admin',
    template: '<admin></admin>',
    authenticate: true,
    admin: "Reporter"
  })

  .state('admin.episodes', {
    url: '/episodes',
    template: '<episodes></episodes>',
    authenticate: true,
    admin: true
  })

  .state('admin.users', {
    url: '/users',
    template: '<users></users>',
    authenticate: true,
    admin: true
  })

  .state('admin.specialties', {
    url: '/specialties',
    template: '<specialties></specialties>',
    authenticate: true,
    admin: true
  })

  .state('admin.episodevalue', {
    url: '/episodevalue',
    template: '<episodevalue></episodevalue>',
    authenticate: true,
    admin: 'Reporter'
  })

  .state('admin.drgs', {
    url: '/drgs',
    template: '<drgs></drgs>',
    authenticate: true,
    admin: true
  })

  .state('admin.site', {
    url: '/site',
    template: '<site></site>',
    authenticate: true,
    admin: true
  })

})

.component('admin', adminComponent);

export default adminModule;



// WEBPACK FOOTER //
// ./client/app/components/admin/admin.js